import { sendGAEvent } from "@next/third-parties/google";
export const sendGAEventTrigger = (eventName: string, params: Record<string, unknown>) => {
  try {
    if (typeof window !== "undefined") {
      sendGAEvent("event", eventName, params);
    } else {
      console.warn(`Google Analytics is not initialized. Event: ${eventName}`);
    }
  } catch (error) {
    console.error(`Failed to send analytics event: ${eventName}`, error);
  }
};
